import { render, staticRenderFns } from "./fireWarnTJ.vue?vue&type=template&id=8fac0960&scoped=true"
import script from "./fireWarnTJ.vue?vue&type=script&lang=js"
export * from "./fireWarnTJ.vue?vue&type=script&lang=js"
import style0 from "./fireWarnTJ.vue?vue&type=style&index=0&id=8fac0960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac0960",
  null
  
)

export default component.exports